import { render, staticRenderFns } from "./UpdateCompany.vue?vue&type=template&id=da898574&scoped=true"
import script from "./UpdateCompany.vue?vue&type=script&lang=js"
export * from "./UpdateCompany.vue?vue&type=script&lang=js"
import style0 from "./UpdateCompany.vue?vue&type=style&index=0&id=da898574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da898574",
  null
  
)

export default component.exports